/**
 * Route table. The `Layout` is mounted at `/` and renders nested children via
 * `<Outlet />`. Devices is the default landing page in Phase 1; Customers /
 * Audit are placeholders pointing at later phases (see §6 of
 * `docs/FLEET_BACKEND_IMPLEMENTATION_PLAN.md`). Releases shipped in Phase 3.
 */

import { Navigate, Route, Routes } from "react-router-dom";

import Layout from "@/components/Layout";
import Customers from "@/pages/Customers";
import Devices from "@/pages/Devices";
import DeviceDetail from "@/pages/DeviceDetail";
import AuditLog from "@/pages/AuditLog";
import Placeholder from "@/pages/Placeholder";
import Releases from "@/pages/Releases";
import StreamDeviceDetail from "@/pages/StreamDeviceDetail";
import StreamDevices from "@/pages/StreamDevices";

export default function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<Navigate to="/devices" replace />} />
        <Route path="/devices" element={<Devices />} />
        <Route path="/devices/:serial" element={<DeviceDetail />} />
        <Route path="/releases" element={<Releases />} />
        <Route path="/customers" element={<Customers />} />
        <Route path="/audit" element={<AuditLog />} />
        <Route path="/stream/devices" element={<StreamDevices />} />
        <Route path="/stream/devices/:publicId" element={<StreamDeviceDetail />} />
        <Route
          path="*"
          element={
            <Placeholder
              title="Not found"
              phase=""
              description="No route matched. Use the sidebar to navigate."
            />
          }
        />
      </Route>
    </Routes>
  );
}
